﻿<script>
    import model from "../../stores/modelStore";

    import PageSection from "../../components/PageSection.svelte";
    import Form from "../../components/Form.svelte";
    import FormRow from "../../components/FormRow.svelte";
    import FormColumn from "../../components/FormColumn.svelte";
    import Checkbox from "../../components/Checkbox.svelte";
    import TextInput from "../../components/TextInput.svelte";

    export let disabled = true;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

    let tellingTruth = false;
    let consent = false;

    if ($model){
        if ($model.tellingTruth === "true" || $model.tellingTruth === true){
            tellingTruth = true;
        }

        if ($model.consentAcceptance === "true" || $model.consentAcceptance === true){
            consent = true;
        }
    }
</script>

<PageSection>
	<Form id="form-confirmation-consent-details">
        <FormRow>
            <div class="col-md-12 col-sm-12">
                <Checkbox {disabled}
                            bind:checked="{tellingTruth}"
                            label="I am telling the truth about the information I have completed in this Registration Form."
                            id="conf-confirmation"></Checkbox>
            </div>
        </FormRow>
        <FormRow>
            <div class="col-md-9 col-sm-9">
                <Checkbox {disabled}
                            bind:checked="{consent}"
                            label="I expressly consent to this method of acceptance in accordance with <u>s10 of the Electronic Transactions Act 2011 (WA)</u>"
                            id="conf-consentAcceptance"></Checkbox>
            </div>
        </FormRow>
        
        <FormRow>
            <FormColumn cols="8">
                <TextInput
                    {disabled}
                    id="conf-signature"
                    label="Claimant's signature"
                    value={$model.claimantSignature}/>
            </FormColumn>
            <div class="col-md-3 col-sm-3">
                <TextInput
                    id="conf-signed-date"
                    {disabled}
                    label = "Date"
                    value={$model.skyDiscovery_SignedDate ? $model.skyDiscovery_SignedDate : $model.signedDate}
                />
            </div>
        </FormRow>
	</Form>
</PageSection>


<style></style>